export const EFFORT = {
    "SMALL": {value: 0,string: "SMALL"},
    "MEDIUM": {value: 1,string: "MEDIUM"},
    "LARGE": {value: 2,string: "LARGE"},
    "NOEFFORT":{value: 3,string: "NOEFFORT"},
  }
  
  export const PRIORITY = {
    "CRITICAL": {value: 4,string: "CRITICAL"},
    "HIGH": {value: 5,string: "HIGH"},
    "MEDIUM": {value: 6,string: "MEDIUM"},
    "LOW": {value: 7,string: "LOW"},
  }
  
 export const STATUS = {
    "ACTIVE": {value: 8,string: "ACTIVE"},
    "PLANNING": {value: 9,string: "PLANNING"},
    "PROMOTED": {value: 10,string: "PROMOTED"},
    "REJECTED": {value: 11,string: "REJECTED"},
  }

 export const RUNSTATUS = {
    "SUCCESS": {value: 0,string: "SUCCESS"},
    "FAILURE": {value: 1,string: "FAILURE"},
  }

  export const SORT_DIRECTION = {
      "ASC" : {value: true, string: "ASC"},
      "DESC" : {value: false, string: "DESC"}
  }

  export const PAGE = {
    "LOGIN" : "LOGIN",
    "SIGNUP" : "SIGNUP",
    "FORGETPASSWORD": "FORGETPASSWORD",
    "HOME": "HOME",
    "SUBMISSION": "SUBMISSION",
    "SIGNUPVC":"SIGNUPVC",
    "TEST": "TEST"
  }